import type { Board, Task } from "../../api.ts";
import { useTheme } from "../../glassTheme.tsx";
import { GlassCard } from "../glass/Glass.tsx";
import { shortDate } from "../../theme.ts";
import { starvingValues } from "../../starvingValues.ts";

/**
 * The one count in the app (§2) — no other number of tasks or entries
 * appears anywhere else, in Board or in Sessions.
 */
export function Strip({ board }: { board: Board }) {
  const { colors } = useTheme();
  const open = board.tasks.filter((t) => t.state === "open");
  const musts = open.filter((t) => t.tier === "must").length;
  const nextDated = [...open].filter((t) => t.due).sort((a, b) => (a.due as string).localeCompare(b.due as string))[0] as Task | undefined;
  const starving = starvingValues(board);

  const line: React.CSSProperties = { fontSize: 13, color: colors.ink2 };
  const fig: React.CSSProperties = { color: colors.ink };

  return (
    <GlassCard padding="12px 16px" style={{ display: "grid", gap: 5 }}>
      <div style={line}><span style={fig}>{musts}</span> must{musts === 1 ? "" : "s"} open</div>
      <div style={line}>
        {nextDated
          ? <>Next dated: <span style={fig}>{shortDate(nextDated.due)} · {nextDated.title}</span></>
          : <>Next dated: <span style={fig}>none</span></>}
      </div>
      {starving.length > 0 && (
        <div style={line}>Nothing serving: <span style={fig}>{starving.map((v) => v.name).join(", ")}</span></div>
      )}
    </GlassCard>
  );
}
